/* eslint-disable import/no-unresolved */
import React, { useRef, useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/bundle';
import 'swiper/css/pagination';
import 'swiper/css/grid';
import 'swiper/css/navigation';
import { Pagination, Autoplay } from 'swiper';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { isEmpty, kebabCase } from 'lodash';
import SwiperNavigationButton from '../layouts/SwiperNavigationButton';
import BoxedContainer from '../layouts/BoxedContainer';

export default function MobilePartnersCards({ data }) {
  const sliderRef = useRef();
  const [swiper, setSwiper] = useState(null);
  const [currSlide, setCurrSlide] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    console.log('Data received:', data);
    if (!isEmpty(data)) {
      setIsLoading(false);
    }
  }, [data]);

  useEffect(() => {
    console.log('Current Slide:', currSlide);
  }, [currSlide]);

  const handleClickNext = () => swiper?.slideNext();
  const handleClickPrev = () => swiper?.slidePrev();

  const activeSlideNumber = currSlide;

  const breakpoints = {
    0: {
      slidesPerView: 1,
      slidesPerGroup: 1,
    },
    320: {
      slidesPerView: 2,
      slidesPerGroup: 1,
    },
    640: {
      slidesPerView: 2,
      slidesPerGroup: 1,
    },
    768: {
      slidesPerView: 2,
      slidesPerGroup: 1,
    },
  };

  if (isLoading) {
    return <div>Loading...</div>; // Display a loading indicator while data is loading
  }

  return (
    <div className="lg:pt-[42px] pt-[30px] lg:hidden">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.3 }}
        viewport={{ once: true }}
        className="relative">
        <Swiper
          ref={sliderRef}
          breakpoints={breakpoints}
          onSwiper={setSwiper}
          spaceBetween={15}
          pagination={{
            type: 'custom',
          }}
          loop
          autoplay={{
            delay: 3000,
          }}
          modules={[Pagination, Autoplay]}
          onSlideChange={({ realIndex }) => setCurrSlide(realIndex)}
          className="">
          {data.map((item, index) => (
            <SwiperSlide key={`${item.content.title}-${index}`}>
              <div
                className={`!h-[140px] skew-x-[20deg] overflow-hidden bg-bg-1 flex-col flex 
                  items-center justify-around py-4 relative ${kebabCase(item.content.title)}`}>
                {isEmpty(item.content.title) || (
                  <div
                    className="relative -left-1 -skew-x-[20deg] text-[12px] 
                    text-[#666] max-w-[90%] 
                    mx-auto font-roboto-condensed-regular mt-2 mb-auto">
                    {item.content.title}
                  </div>
                )}
                <a
                  href={item.content.link.url}
                  target="_blank"
                  aria-label={item.content.title}
                  rel="noreferrer"
                  className='w-[50%] h-[50%] flex items-center'
                  >
                  <LazyLoadImage
                    src={item.content.image.url}
                    alt={item.content.title}
                    className="object-contain transition-all duration-400
                  ease-in-out -skew-x-[20deg] my-auto max-h-full"
                  />
                </a>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </motion.div>

      <BoxedContainer>
        {data.length > 2 ? (
          <div className="flex flex-row items-center gap-x-4 lg:pt-[60px] pt-[30px]">
            <div className="relative flex flex-row gap-x-4">
              <SwiperNavigationButton
                type="prev"
                clickHandler={handleClickPrev}
                icon="black-prev-arrow"
                className="partners-prev-button"
              />
              <SwiperNavigationButton
                type="next"
                clickHandler={handleClickNext}
                icon="black-next-arrow"
                className="partners-next-button"
              />
            </div>
            <p
              className="text-primary font-roboto-regular md:text-[23px] text-[21px] md:leading-8
          leading-7">
              {activeSlideNumber + 1} - {data.length}
            </p>
          </div>
        ) : (
          ''
        )}
      </BoxedContainer>
    </div>
  );
}